<template>
  <div class="change-password">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">{{ module.Name }}</div>
      </q-card-section>
      <q-separator />
        <q-card-section class="card-content">
          <q-input
            square
            outlined
            label="Current Email"
            type="email"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.currentEmail"
            @update:model-value="(e) => fields.currentEmail = e"
            @blur="v$.fields.currentEmail.$touch()"
            :error="v$.fields.currentEmail.$error"
            :error-message="getErrorMesage('currentEmail')"
          />
          <q-input
            square
            outlined
            type="email"
            label="New Email"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.newEmail"
            @update:model-value="(e) => fields.newEmail = e"
            @blur="v$.fields.newEmail.$touch()"
            :error="v$.fields.newEmail.$error"
            :error-message="getErrorMesage('newEmail')"
          />
          <q-input
            square
            outlined
            label="PIN"
            type="password"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.pin"
            @update:model-value="(e) => fields.pin = e"
            @blur="v$.fields.pin.$touch()"
            :error="v$.fields.pin.$error"
            error-message="Pin is required"
          />
        <q-btn class="change-password-btn" label="Submit" @click="submit"/>
      </q-card-section>
    </q-card>
  </div>
</template>
  <script>
  import { mapActions } from 'vuex';
  import { required, email } from "vuelidate/lib/validators";
  import { useVuelidate } from '@vuelidate/core'
  
  export default {
    name: 'ChangeEmail',
    props: {
      module: {
        require: true,
        type: Object
      }
    },
    setup () {
      return { v$: useVuelidate() }
    },
    validations () {
      return {
        fields: {
          currentEmail: {
            required,
            email
          },
          newEmail: {
            required,
            email
          },
          pin: {
            required
          }
        }
      }
    },
    data () {
      return {
        fields: {
          currentEmail: null,
          newEmail: null,
          pin: null,
          captcha: null
        }
      }
    },
    methods: {
      ...mapActions({
        changeEmail: 'user/changeEmail'
      }),
      getErrorMesage (field) {
        let message = ''
        this.v$.$errors.forEach(element => {
          if(element.$property === 'currentEmail' && field === 'currentEmail') {
            if (element.$validator === 'required') {
              message = 'Current email is required'
              return
            } else if (element.$validator === 'email') {
              message = 'Current email must be valid email address'
              return
            }
          } else if (element.$property === 'newEmail' && field === 'newEmail') {
            if (element.$validator === 'required') {
              message = 'New email is required'
              return
            } else if (element.$validator === 'email') {
              message = 'New email must be valid email address'
              return
            }
          }

        });

        return message
      },
      async submit () {
        this.v$.fields.$touch()

        if (this.v$.fields.$invalid) {
          return
        }

        this.$q.loading.show();
        
        await this.recaptchaLoad('changeemail')
  
        await this.changeEmail(this.fields)
          .then(async () => {
            await this.recaptchaLoad('changeemail')

            this.resetFields()

            this.$q.notify({
              position: 'top-right',
              message: 'Change Email Success!',
              type: 'positive'
            })
  
            this.$q.loading.hide()
          })
          .catch((error) => {
            this.$q.notify({
              position: 'top-right',
              message: error.response.data.message,
              type: 'negative'
            })
  
            this.$q.loading.hide();
          })
      },
      resetFields() {
        this.v$.fields.$reset()
        this.fields = {
          oldPassword: null,
          newEmail: null,
          pin: null,
          captcha: null
        }
      }
    }
  }
</script>
<style lang="scss">
.change-password {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
    }

    .q-input {
      color: white;
    }

    .q-field__control:before {
      border-color: white;
    }
    
    .change-password-btn {
      background-color: #FFC108;
    }
  }

  .q-layout__section--marginal {
    background-color: $background;
  }
}
</style>